export const OutlookCalendarGetters = {
  isOutlookCalendarAccessible: state => state.calendarInfo.accessible,
  isOutlookCalendarConfigured: state => !!state.calendarInfo.id,
  isOutlookCalendarEnabled: state => !!state.calendarInfo.enabled,
  isOutlookCalendarLinked: state => state.calendarInfo.linked,
  isOutlookCalendarSyncing: state => state.calendarInfo.sync?.running,
  outlookCalendarInfo: state => state.calendarInfo,
  outlookCalendarSyncProgress: state => state.calendarInfo.sync?.progress || 0,
}
